export default {
  header: "Don't have an account?",
  button: 'CONTINUE AS A GUEST',
  body: "As a guest, you'll be able to view your results but you won't be able to save them for the next time."
};
